<div class="tw-max-w-[920px] tw-px-6 lg:tw-px-0 tw-mx-auto tw-my-[20px]">
    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-3">
        <img
            src="/assets/images/matched-product/bulb.png"
            alt="bulb"
            class="tw-h-[25px] tw-min-w-[20px]"
        />
        <h2
            class="!tw-text-blue-900 !tw-text-[18px] !tw-mb-0 !tw-leading-[1.5]"
        >
            {{ "FINANCING_CALCULATOR.NOT_FOUND" | translate }}
        </h2>
    </div>
    <div
        class="tw-rounded-2xl tw-px-[40px] tw-py-[20px] tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-between tw-gap-4 tw-border tw-border-[#4B6EEC]"
    >
        <div
            class="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-4"
        >
            <div class="">
                <img
                    src="/assets/images/fin-calculator/vault.png"
                    alt="vault"
                    class="tw-min-w-[120px] tw-w-[160px]"
                />
            </div>
            <div class="tw-max-w-[480px] tw-text-center sm:tw-text-left">
                <h3 class="!tw-font-bold !tw-mb-3 !tw-text-[18px]">
                    {{ "FINANCING_CALCULATOR.PRODUCTS" | translate }}
                </h3>
                <p class="!tw-mb-0">
                    {{ "FINANCING_CALCULATOR.OTHER_PRODUCTS" | translate }}
                </p>
                <p>
                    {{ "FINANCING_CALCULATOR.VIEW_MORE" | translate }}
                </p>
            </div>
        </div>
        <div class="">
            <a
                ga-event-id="explore_more_button_financing_calculator_click"
                ga-event-category="Financing Calculator Button"
                ga-event-label="Explore More Button Click"
                ga-track="track"
                href="/business-financing"
                class="tw-text-white tw-rounded-full tw-bg-[#FFAD3C] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-4 tw-w-[175px]"
            >
                {{ "FINANCING_CALCULATOR.EXPLORE_MORE" | translate }}
            </a>
        </div>
    </div>
</div>
